<template>
  <transition name="dialog-fade">
    <div class="download-dialog-overlay" v-if="show" @click.self="downloadCloseHandle">
      <div class="download-dialog">
        <div class="platform-card">
          <img class="platform-icon" src="../assets/images/window_icon.png" alt="Windows" />
          <p class="platform-name">Windows</p>
          <button class="download-btn" @click="downloadHandle('windows')">点击下载</button>
        </div>
        <div class="platform-card">
          <img class="platform-icon" src="../assets/images/mac_icon.png" alt="macOS" />
          <p class="platform-name">macOS</p>
          <button class="download-btn" @click="downloadHandle('mac')">点击下载</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'DownloadDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    downloadCloseHandle () {
      this.$emit('update:show', false)
    },
    downloadHandle (platform) {
      this.$emit('download', platform)
    }
  }
}
</script>

<style scoped>
.download-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.download-dialog {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
}

.platform-card {
  width: 398px;
  height: 294px;
  background: #ffffff;
  border-radius: 28px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.platform-icon {
  width: 50px;
  height: 50px;
  margin-bottom: 8px;
  object-fit: contain;
}

.platform-name {
  font-size: 24px;
  color: #333333;
  margin: 0 0 53px;
  text-align: center;
  font-weight: bold;
}

.download-btn {
  width: 237px;
  height: 51px;
  background: #1a1a1a;
  color: #ffffff;
  font-size: 16px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  outline: none;
}

.download-btn:hover {
  background: #333333;
}

.download-btn:active {
  background: #000000;
}

.dialog-fade-enter-active,
.dialog-fade-leave-active {
  transition: opacity 0.3s ease;
}

.dialog-fade-enter,
.dialog-fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// DownloadDialog.vue?284c0d55